import React from 'react';
import PropTypes from 'prop-types';
import RoomsDropDown from '../RoomsDropDown';
import RoomTypesDropDown from '../RoomTypesDropDown';
import WingDropDown from '../WingDropDown';
import MarketSegmentsDropDown from '../MarketSegmentsDropDown';
import { useMemo } from 'react';
import { EntityType as EntityTypes } from '../constants';

const DynamicEntityDropDown = ({
  EntityTypeId = EntityTypes.Room,
  ...rest
}) => {
  const MemoizedCustomComponent = useMemo(
    () =>
      ({
        [EntityTypes.Room]: RoomsDropDown,
        [EntityTypes.RoomType]: RoomTypesDropDown,
        [EntityTypes.Wings]: WingDropDown,
        [EntityTypes.MarketSegment]: MarketSegmentsDropDown,
      }[EntityTypeId]),
    [EntityTypeId]
  );

  if (!MemoizedCustomComponent)
    throw new Error('No imported dropdown for entityTypeId: ' + EntityTypeId);

  return <MemoizedCustomComponent {...rest} />;
};

DynamicEntityDropDown.propTypes = {
  EntityTypeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DynamicEntityDropDown;
